import React from 'react'

export default ({value, disabled, onChange}) => {
  return (
    <span className="input-group percentage-input">
      <input type="text" className="form-control" value={value} onChange={onChange} disabled={disabled} />
      <div className="input-group-append"><span className="input-group-text">%</span></div>
    </span>
  );
}
